import { jsx as h, Fragment as m, jsxs as p } from "react/jsx-runtime";
import { useState as M, useEffect as y } from "react";
import { Button as C } from "antd";
import "../../../../../main/components/SimpleModal/index.js";
import { useSimpleModal as P } from "../../../../../main/components/SimpleModal/hooks.js";
const w = (o) => {
  var i;
  const n = o == null ? void 0 : o.onConfirm, e = (o == null ? void 0 : o.initItems) || [], { modalProps: c, setModalProps: s, show: f, close: r } = P(), [t, l] = M(
    []
  ), u = {
    title: "媒體庫",
    footer: /* @__PURE__ */ h(m, { children: /* @__PURE__ */ p(C, { type: "primary", onClick: () => {
      r(), n == null || n(t);
    }, children: [
      "確定選取 (",
      t == null ? void 0 : t.length,
      ")"
    ] }) }),
    onCancel: r,
    destroyOnHidden: !0,
    ...c
  };
  return y(() => {
    l(e);
  }, [(i = e == null ? void 0 : e.map((d) => (d == null ? void 0 : d.id) || "")) == null ? void 0 : i.join(",")]), {
    show: f,
    close: r,
    modalProps: u,
    setModalProps: s,
    selectedItems: t,
    setSelectedItems: l
  };
};
export {
  w as useMediaLibraryModal
};
